import { PriceType, ProductType } from '@wix/ambassador-forms-v4-form/types';
import { generateUUID } from '@wix/form-schema';
import { getProductPrice } from '../../field-settings/settings-shared/products/product-price';
export function toProductValue(product, value) {
    const price = Number(value || '0');
    return {
        productId: product.id,
        price: product.priceType === PriceType.DYNAMIC_PRICE ? price : String(price),
        quantity: 1
    };
}
export function findProductWithDynamicPrice(products) {
    return products.find((product)=>product.priceType === PriceType.DYNAMIC_PRICE);
}
export function aDynamicPriceProduct() {
    return {
        id: generateUUID(),
        priceType: PriceType.DYNAMIC_PRICE,
        productType: ProductType.DIGITAL,
        quantityLimit: {
            minimum: 1,
            maximum: 1
        },
        dynamicPriceOptions: {
            minPrice: '0'
        }
    };
}
export function aFixedPriceProduct(price, id = generateUUID()) {
    return {
        id,
        priceType: PriceType.FIXED_PRICE,
        productType: ProductType.DIGITAL,
        quantityLimit: {
            minimum: 1,
            maximum: 1
        },
        fixedPriceOptions: {
            price: String(price)
        }
    };
}
export function excludeProductsWithDynamicPrice(products) {
    return products.filter((product)=>product.priceType !== PriceType.DYNAMIC_PRICE);
}
export function getCustomAmount(productValue, customAmountProduct) {
    return productValue?.productId === customAmountProduct?.id ? String(productValue?.price ?? '') : '';
}
export function getProductValueOnCheckboxChange(productId, productValue, productsById) {
    const newValue = productValue?.productId === productId ? undefined : productId;
    const product = newValue ? productsById[newValue] : undefined;
    return product ? [
        toProductValue(product, getProductPrice(product))
    ] : [];
}

//# sourceMappingURL=donation-field-utils.js.map